import { useState } from "react";
import { useParams } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import { CONTACT_REASONS, deskHolderName, submitPortalMessage } from "../../js/prospects";

const EMPTY = {
  name: "",
  email: "",
  phone: "",
  message: "",
  reason: "general",
  property_of_interest: "",
  meeting_time: "",
};

export default function ProspectPortal() {
  const { deskId } = useParams();
  const host = deskHolderName(deskId);
  const [form, setForm] = useState(EMPTY);
  const [note, setNote] = useState("");
  const [error, setError] = useState("");

  function update(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  function submit(event) {
    event.preventDefault();
    setError("");
    setNote("");
    try {
      submitPortalMessage(form, deskId);
      setNote("Thank you. Your note is with the office. They will follow up.");
      setForm(EMPTY);
    } catch (err) {
      setError(err.message || "We could not send that yet.");
    }
  }

  if (!host) {
    return (
      <AppLayout variant="public">
        <article className="card auth-card">
          <h1>Write to the office</h1>
          <p>That door could not be found. Please ask your agent for a fresh link.</p>
        </article>
      </AppLayout>
    );
  }

  return (
    <AppLayout variant="public">
      <article className="card auth-card prospects-portal">
        <p className="eyebrow">A quiet first note</p>
        <h1>Write to {host}</h1>
        <p className="page-lead">
          You do not need an account. This note goes to the office and becomes a kind first
          conversation — not a marketplace listing.
        </p>
        {note ? <p className="confirm-banner">{note}</p> : null}
        {!note ? (
          <form className="stack" onSubmit={submit}>
            <label className="field">
              <span className="field-label">Name</span>
              <input className="field-input" name="name" value={form.name} onChange={update} required />
            </label>
            <label className="field">
              <span className="field-label">Email</span>
              <input className="field-input" type="email" name="email" value={form.email} onChange={update} required />
            </label>
            <label className="field">
              <span className="field-label">Phone (optional)</span>
              <input className="field-input" name="phone" value={form.phone} onChange={update} />
            </label>
            <label className="field">
              <span className="field-label">Reason for contact</span>
              <select className="field-select" name="reason" value={form.reason} onChange={update}>
                {CONTACT_REASONS.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.label}
                  </option>
                ))}
              </select>
            </label>
            <label className="field">
              <span className="field-label">Property of interest (optional)</span>
              <input className="field-input" name="property_of_interest" value={form.property_of_interest} onChange={update} />
            </label>
            <label className="field">
              <span className="field-label">Preferred meeting time (optional)</span>
              <input className="field-input" name="meeting_time" value={form.meeting_time} onChange={update} placeholder="Thursday morning, or a date" />
            </label>
            <label className="field">
              <span className="field-label">Message</span>
              <textarea className="field-textarea" name="message" rows={5} value={form.message} onChange={update} required />
            </label>
            {error ? <p className="field-error">{error}</p> : null}
            <button className="primary-btn" type="submit">
              Send the note
            </button>
          </form>
        ) : null}
      </article>
    </AppLayout>
  );
}
